var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.797 7.6h2.4V6H13.6c.881 0 1.596.715 1.596 1.595v9.61c0 .88-.714 1.595-1.596 1.595H2.393a1.597 1.597 0 01-1.596-1.595v-9.61C.797 6.715 1.51 6 2.393 6h2.404v1.6h2.4V.8c0-.441.355-.8.8-.8.442 0 .8.356.8.8v6.8zm-1.6 0h-4.8v9.6h11.2V7.6h-4.8v4.068l.903-.904a.8.8 0 011.131 1.131L8.56 14.17A.787.787 0 018 14.4l-.006-.002a.787.787 0 01-.557-.23l-2.274-2.273a.8.8 0 011.131-1.131l.902.901V7.6z",
    fill: "#085FE5"
  })));
}

export default SvgDownload;